import React from 'react';

const IcoHockey = ({ className }) => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='14'
            height='14'
            viewBox='0 0 14 14'
            className={className}
        >
            <g id='Ice_Hockey' data-name='Ice Hockey' transform='translate(-54.008 -311.202)'>
                <path
                    id='Path_3105'
                    data-name='Path 3105'
                    d='M65.228,324.893a3.916,3.916,0,0,1-2.557-1.352q-3.808-4.153-7.6-8.324a1.337,1.337,0,0,1-.338-1.339,1.136,1.136,0,0,1,.95-.868,1.157,1.157,0,0,1,1.072.455q2.473,2.718,4.955,5.425c.728.8,1.451,1.6,2.193,2.378a.789.789,0,0,0,.5.225c.738.025,1.478.006,2.217.012a1.256,1.256,0,0,1,1.259,1.574C67.75,324.2,66.908,324.91,65.228,324.893Z'
                    transform='translate(0.111 0.299)'
                />
                <path
                    id='Path_3106'
                    data-name='Path 3106'
                    d='M56.387,320.421a2.706,2.706,0,0,1,.435,0,1.529,1.529,0,0,0,1.641-.707c.226-.328.441-.3.706-.02.322.342.632.694.951,1.039a.491.491,0,0,1,0,.755c-.337.362-.659.742-1.009,1.09a4.1,4.1,0,0,1-3.277,1.23A2.019,2.019,0,0,1,54.027,322a1.271,1.271,0,0,1,1.2-1.571C55.61,320.413,56,320.423,56.387,320.421Z'
                    transform='translate(0 1.379)'
                />
                <path
                    id='Path_3107'
                    data-name='Path 3107'
                    d='M64.705,313.081a1.187,1.187,0,0,1,1.221.748,1.24,1.24,0,0,1-.19,1.363c-1.093,1.218-2.2,2.42-3.3,3.627a.391.391,0,0,1-.661,0c-.323-.357-.646-.715-.974-1.067a.472.472,0,0,1-.009-.721c1.1-1.205,2.2-2.421,3.319-3.608A2.006,2.006,0,0,1,64.705,313.081Z'
                    transform='translate(1.103 0.313)'
                />
                <path
                    id='Path_3108'
                    data-name='Path 3108'
                    d='M58,313.1c0-1.185.247-1.528,1.321-1.779a4.141,4.141,0,0,1,2.437.131,1.192,1.192,0,0,1,.9,1.374c0,.184,0,.37,0,.555,0,.82-.149,1.072-.857,1.363a3.74,3.74,0,0,1-2.981-.019c-.686-.292-.825-.54-.821-1.347C58,313.289,58,313.2,58,313.1Zm3.849-.637c-.789-.567-2.53-.534-3.018.041A2.979,2.979,0,0,0,61.851,312.467Z'
                    transform='translate(0.665 0)'
                />
            </g>
        </svg>
    );
};

export default IcoHockey;
